import css from './index.module.css'

export interface Resolution {
    height: number
    maxWidth?: number
    width: number
}
interface Props {
    alt?: string
    resolutionList: Resolution[]
    src?: string
}

export const IMAGE_NOT_FOUND = 'https://cdn1.idek.cz/img/2711ac4e3e85e0ac6233b02388095dbb.webp'
export const Image = ({ alt, resolutionList, src }: Props) => {
    src ??= IMAGE_NOT_FOUND
    // !make mutation!
    const res = [...resolutionList] // copy because of shift and <React.StrictMode> with double render
    const defaultResolution = res.shift() // take index 0 as default resolution

    return (
        <picture className="r-image">
            {/* index >= 1 */}
            {res.map(({ height, maxWidth, width }, index) => (
                <source
                    key={index}
                    height={height}
                    media={maxWidth ? `(max-width: ${maxWidth}px)` : undefined}
                    srcSet={src.replace('.webp', `_ew${width}_eh${height}.webp`)}
                    type="image/webp"
                    width={width}
                />
            ))}
            {/* index == 0 */}
            <img
                className={css.image}
                src={src.replace('.webp', `_ew${defaultResolution?.width}_eh${defaultResolution?.height}.webp`)}
                width={defaultResolution?.width}
                height={defaultResolution?.height}
                alt={alt}
            />
        </picture>
    )
}
